import * as Yup from "yup";
const validationSchema = Yup.object().shape({
  FirstName: Yup.string().required("First Name is required"),
  CompanyName: Yup.string().required("Company Name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  phoneNumber: Yup.number().required("Phone number is required"),
  Location: Yup.string().required("Location is required"),
});

export { validationSchema };
